import { jsx as e } from "react/jsx-runtime";
import { useState as s } from "react";
import { useMultiStyleConfig as d, Box as p } from "@chakra-ui/react";
import { motion as f } from "framer-motion";
import { useGlobalNavContext as u } from "./useGlobalNavv2Context.mjs";
import { maxGlobalNavWidth as b, globalNavMainWidth as v } from "../../theme/components/navigation/globalNavv2.mjs";
const N = ({ children: i, category: a }) => {
  const l = d("GlobalNavv2"), { isOpen: o, rootId: n, setMenuItems: r } = u(), [m, t] = s(!o);
  return /* @__PURE__ */ e(
    f.div,
    {
      hidden: m,
      initial: !1,
      onAnimationStart: () => t(!1),
      onAnimationComplete: () => {
        t(!o), o || r([]);
      },
      animate: { width: o ? b - v : 0 },
      style: l.slider,
      children: /* @__PURE__ */ e(p, { padding: 6, id: `${n}-panel`, role: "menu", "aria-labelledby": a, children: i })
    }
  );
};
N.displayName = "GlobalNavMenuSlider";
export {
  N as GlobalNavMenuSlider
};
